import React from 'react'
import styled from 'styled-components'
import Title from '../custom/Title'
import { Breadcrumbs, Chip, ChipTypeMap } from '@mui/material'
import { emphasize, styled as mStyled } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { PageContext } from '../../contexts/PageContext';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { TStepsKeys } from '../../Models/common';
import { TransactionContext } from '../../contexts/TransactionContext';
import { NotificationContext } from '../../contexts/NotificationContext';
import { TRANSACTION_STATUS } from '../../utils/constant';

const Container = styled.div`
    width:100%;
    display:flex;
    /* background: #f1f1f1; */
    padding:15px 20px 0 20px;
    gap:40px;
    align-items:center;
`

const StyledBreadcrumb = mStyled<OverridableComponent<ChipTypeMap<{is_active:boolean}, "div">>>(Chip)(({ theme, is_active }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: is_active ? theme.palette.primary.contrastText : theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        background: is_active ? theme.palette.primary.main : backgroundColor,
        '&:hover, &:focus': {
            backgroundColor: is_active ? theme.palette.primary.main : emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: is_active ? theme.palette.primary.main : emphasize(backgroundColor, 0.12),
        },
    };
});

export interface IBreacrumbs {
    path: string;
    label: string
}

const CustomBreadcrumbs = () => {
    const { capturedSteps, transactionInfo } = React.useContext(TransactionContext)
    const { pageState } = React.useContext(PageContext)
    const { notify } = React.useContext(NotificationContext)
    const { title, breadcrumbs, currentPage, path } = pageState
    const navigate = useNavigate()
    const { id } = useParams()

    const getPrevStepIndex = (stepKey: string) => {
        const currentIndex = breadcrumbs.findIndex(crumb => crumb.path === stepKey)
        return currentIndex - 1        
    }

    return breadcrumbs?.length > 0 ?
        <Container>
            <Title>{title}</Title>
            <Breadcrumbs aria-label="breadcrumb">
                {breadcrumbs.map((breadcrumb, index) => {
                    const props = {
                        label:breadcrumb.label, 
                        onClick: () => { 
                            if([TRANSACTION_STATUS.CANCELLED, TRANSACTION_STATUS.PENDING_CANCELLATION].includes(transactionInfo.status)) {
                                return notify(`Transaction has been cancelled`, 'error')
                            }
                            const prevStepIndex = index - 1
                            if(prevStepIndex > -1){
                                const prevStep = breadcrumbs[prevStepIndex]
                                if(!capturedSteps.includes(prevStep.path as TStepsKeys))
                                return notify(`Please complete ${prevStep.label} first`, 'error')
                            }
                            if(id) navigate(path + '/' + id + '?section=' + breadcrumb.path) 
                            else navigate(path + '?section=' + breadcrumb.path) 
                        },
                        is_active: currentPage === breadcrumb.path
                    }
                    return <StyledBreadcrumb key={'breadcrumb_' + breadcrumb.path} {...props} />
                })}
            </Breadcrumbs>
        </Container>
        : <></>
}

export default CustomBreadcrumbs